import { SearchX, UtensilsCrossed } from "lucide-react";
import { makeT } from "@/i18n/strings";

export const readLang = () => {
  try {
    const v = localStorage.getItem("wt_lang");
    return v === "en" || v === "ar" ? v : null;
  } catch {
    return null;
  }
};

export const saveLang = (l) => {
  try {
    localStorage.setItem("wt_lang", l);
  } catch {}
};

export const MenuSkeleton = () => (
  <div className="min-h-screen bg-[#121214] p-4" data-testid="menu-loading">
    <div className="mx-auto max-w-6xl space-y-4">
      <div className="h-12 w-48 animate-pulse rounded-full bg-white/5" />
      <div className="h-52 animate-pulse rounded-3xl bg-white/5" />
      <div className="flex gap-2">{[1, 2, 3, 4].map((i) => <div key={i} className="h-10 w-24 animate-pulse rounded-full bg-white/5" />)}</div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">{[1, 2, 3].map((i) => <div key={i} className="aspect-[4/3] animate-pulse rounded-2xl bg-white/5" />)}</div>
    </div>
  </div>
);

export const MenuError = ({ onRetry }) => {
  const t = makeT(readLang() || "en");
  return (
    <div className="grid min-h-screen place-items-center bg-[#121214] p-6 text-center text-white" data-testid="menu-error">
      <div className="space-y-4">
        <UtensilsCrossed className="mx-auto h-10 w-10 text-orange-500" />
        <p className="text-lg font-semibold">{t("pub.loadError")}</p>
        <button onClick={onRetry} data-testid="menu-retry-btn" className="rounded-full bg-orange-500 px-6 py-2.5 font-semibold">{t("pub.retry")}</button>
      </div>
    </div>
  );
};

export const EmptyState = ({ title, hint, search, onClear, clearLabel }) => (
  <div className="flex flex-col items-center gap-3 py-20 text-center" data-testid={search ? "search-empty-state" : "menu-empty-state"}>
    <span className="grid h-16 w-16 place-items-center rounded-full" style={{ background: "color-mix(in srgb, var(--wt-primary) 15%, transparent)" }}>
      {search ? <SearchX className="h-7 w-7" style={{ color: "var(--wt-primary)" }} /> : <UtensilsCrossed className="h-7 w-7" style={{ color: "var(--wt-primary)" }} />}
    </span>
    <p className="text-lg font-bold">{title}</p>
    {hint && <p className="max-w-xs text-sm text-[var(--wt-muted)]">{hint}</p>}
    {onClear && <button onClick={onClear} data-testid="search-empty-clear-btn" className="mt-2 rounded-full px-5 py-2 text-sm font-semibold text-white" style={{ background: "var(--wt-primary)" }}>{clearLabel}</button>}
  </div>
);
